import { observer } from 'mobx-react';

import StatsBox from '../../../../components/stats-box';
import { useOnboardingStore } from '../../../../contexts/mobx';
import { OnboardingData } from '../../../../stores/onboarding';
import {
    friendlyNames,
    iconsMap,
    calculateDifference,
    sortOnboardingSteps,
} from '../../utils/index';
import { OnboardingSection } from '../onboarding-section';
import style from '../../style.module.scss';

function getStepDifference(step: OnboardingData, prevSteps: OnboardingData[]) {
    const completedCountOfPreviousPeriod =
        prevSteps.find(
            (prev) => prev.onboardingStepName === step.onboardingStepName
        )?.completedCount ?? 0;

    return calculateDifference(
        step.completedCount,
        completedCountOfPreviousPeriod
    );
}

export const OnboardingStepsSection = observer(
    ({ isComparing }: { isComparing: boolean }) => {
        const onboardingStore = useOnboardingStore();
        const orderedSteps = sortOnboardingSteps(
            onboardingStore.onboardingData
        );

        return (
            <OnboardingSection
                title="Onboarding reach (per page)"
                isLoading={onboardingStore.isFetchingOnboardingData}
            >
                <div className={style.steps_container}>
                    {orderedSteps.map((step, index) => {
                        return (
                            <StatsBox
                                key={index}
                                title={
                                    friendlyNames[step.onboardingStepName] ||
                                    step.onboardingStepName
                                }
                                currentValue={step.completedCount}
                                difference={
                                    isComparing
                                        ? getStepDifference(
                                              step,
                                              onboardingStore.onboardingDataPrevious
                                          )
                                        : undefined
                                }
                                icon={
                                    iconsMap[step.onboardingStepName] ||
                                    iconsMap['IN_PROGRESS']
                                }
                            />
                        );
                    })}
                </div>
            </OnboardingSection>
        );
    }
);
